export default "__VITE_ASSET__8e1a88a4__"